import React, { ReactNode } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

export interface SideNavContentProps {
    path: string;
    light?: boolean;
    children?: ReactNode;
}

class SideNavContent extends React.Component<SideNavContentProps> {
  render() {
    return (
      <section className="sidebar-content">
        <Scrollbars style={{ height: "100%" }}>
          <ul
            className={`navigation ${
              this.props.light ? "navigation--light" : ""
            }`}
          >
            {this.props.children}
          </ul>
        </Scrollbars>
      </section>
    );
  }
}

export default SideNavContent;
